import { IFilterReferences } from "src/common/types";
import { getCall } from "src/services";

export const getFilterReferences = (): Promise<IFilterReferences> => {
  return getCall({ url: `/v1/feedback/participant-search/auto-suggestion` }) as Promise<IFilterReferences>;
};

export const fetchFilterReferences = () => ({
  type: "GET_FILTER_REFERENCES"
});
